import React from "react";

import Input from "../../controls/Input";

import { useForm } from "../useForm";
import Button from "../../controls/Button";

const initialFValues = {
  current_password: "",
  new_password: "",
  new_password_confirmation: "",
};

export default function MyPasswordForm(props) {
  const { updateAccountPassword } = props;

  var loading = false;

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("current_password" in fieldValues) {
      temp.current_password = null;
      if (fieldValues.current_password === "") {
        temp.current_password = "This field is required.";
      }
    }

    if ("new_password" in fieldValues) {
      temp.new_password = null;
      if (fieldValues.new_password === "") {
        temp.new_password = "This field is required.";
      }
    }

    if ("new_password_confirmation" in fieldValues) {
      temp.new_password_confirmation = null;
      if (fieldValues.new_password_confirmation === "") {
        temp.new_password_confirmation = "This field is required.";
      }

      if (fieldValues.new_password_confirmation !== values.new_password) {
        temp.new_password_confirmation = "The passwords do not match.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const { values, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false,
    validate,
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      updateAccountPassword(values);
    }
  };

  return (
    <section className="overflow-hidden rounded-2xl border border-border-subtle bg-card shadow-soft">
      <div className="border-b border-border-subtle px-6 py-5">
        <h2 className="text-base font-semibold text-brand">Password</h2>
        <p className="mt-1 text-sm text-slate-500">
          Choose a strong password to keep your account secure.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5 p-6">
        <Input
          label="Current password"
          name="current_password"
          onChange={handleInputChange}
          value={values.current_password}
          labelOn={true}
          type="password"
          error={errors.current_password}
        />

        <Input
          label="New password"
          name="new_password"
          onChange={handleInputChange}
          value={values.new_password}
          labelOn={true}
          type="password"
          error={errors.new_password}
        />

        <Input
          label="Confirm password"
          name="new_password_confirmation"
          onChange={handleInputChange}
          value={values.new_password_confirmation}
          labelOn={true}
          type="password"
          error={errors.new_password_confirmation}
        />

        <div className="flex justify-end border-t border-border-subtle pt-5">
          <Button type="submit" className="h-10 px-4" loading={loading}>
            Update password
          </Button>
        </div>
      </form>
    </section>
  );
}
